// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__3E2fW","before":"NavItem_before__2o02O","linkActive":"NavItem_linkActive__20Hi2","active":"NavItem_active__1qpup"};